* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.container {
  overflow: hidden;
  gz-form-field#integration-instances {
    position: relative;
    overflow: visible;

    gz-single-select-complex {
      position: fixed;
      z-index: 1;
    }
  }
}


